import { render, staticRenderFns } from "./MainRadicacion.vue?vue&type=template&id=2379cde4"
import script from "./MainRadicacion.vue?vue&type=script&lang=js"
export * from "./MainRadicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports